import gql from 'graphql-tag'

export const GET_PRODUCT_PRICE_COINS_POLICY_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getProductPriceCoinsPolicyPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
				level {
					level
					title
				}
        discount
      }
    }
  }
`;

export const GET_PRODUCT_PRICE_COINS_POLICY_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProductPriceCoinsPolicy (
      data: {
        id: $id
      }
    ) {
      id
      discount
			level {
				level
				title
			}
    }
  }
`;
